<template>
    <DCard
        padding
    >
        <DTable
            :items="taxRulesCreditNotes"
            :fields="getFields"
            hover
            sorter
        >
            <template #country_name="{item}">
                <td>
                    {{ item.country_code ? item.country_name : '-' }}
                </td>
            </template>
            <template #tax_rate="{item}">
                <td>{{ item.tax_rate }}%</td>
            </template>
            <template #customer_type="{item}">
                <td>{{ __(`customers.customers.customer_types.${item.customer_type}`) }}</td>
            </template>
            <template #no_tax="{item}">
                <td>{{ item.no_tax ? __('settings.tax-rules-credit-notes.index.table.values.no_tax.yes') : __('settings.tax-rules-credit-notes.index.table.values.no_tax.no') }}</td>
            </template>
            <template #text="{item}">
                <td>{{ item.text !== null ? item.text : '' }}</td>
            </template>
            <template #credit_note_type_name="{item}">
                <td>
                    <Link :href="$route('settings.credit-note-types.edit', { credit_note_type: item.credit_note_type_id })">
                        {{ item.credit_note_type_name }}
                    </Link>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DButton
                            :id="`edit_${item.id}`"
                            mini
                            icon="pencil"
                            @click="$inertia.get(editTaxRulesCreditNotesLink(item.id))"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="isInLoadingState"
                            @click="deleteTaxRule(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.tax-rules-credit-notes.index.add_rule_button')"
                @click="$inertia.get($route('settings.tax-rules-credit-notes.create'))"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.tax-rules-credit-notes.delete_confirm_modal.title')"
            :message="__('settings.tax-rules-credit-notes.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script>
export default {
    name: 'TaxRulesCreditNotesIndex',
    props: {
        taxRulesCreditNotes: {
            type: Array,
            default: () => { return [] }
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            deleteCallBack: () => { return {} }
        }
    },
    computed: {
        getFields () {
            if (this.isFinanceSystemNetsuite === true) {
                return [
                    {
                        key: 'id',
                        label: this.__('settings.tax-rules-credit-notes.index.table.headers.id'),
                        _classes: 'sorter-country'
                    },
                    {
                        key: 'country_name',
                        label: this.__('settings.tax-rules-credit-notes.index.table.headers.country_name'),
                        _classes: 'sorter-country'
                    },
                    {
                        key: 'tax_rate',
                        label: this.__('settings.tax-rules-credit-notes.index.table.headers.tax_rate'),
                        _classes: 'sorter-tax-rate'
                    },
                    {
                        key: 'tax_key',
                        label: this.__('settings.tax-rules-credit-notes.index.table.headers.tax_key'),
                        _classes: 'sorter-tax-key'
                    },
                    {
                        key: 'customer_type',
                        label: this.__('settings.tax-rules-credit-notes.index.table.headers.customer_type'),
                        _classes: 'sorter-customer-type'
                    },
                    {
                        key: 'no_tax',
                        label: this.__('settings.tax-rules-credit-notes.index.table.headers.no_tax'),
                        _classes: 'sorter-no-tax'
                    },
                    {
                        key: 'credit_note_type_name',
                        label: this.__('settings.tax-rules-credit-notes.index.table.headers.credit_note_type_name'),
                        _classes: 'sorter-credit-note-type'
                    },
                    {
                        key: 'text',
                        label: this.__('settings.tax-rules-credit-notes.index.table.headers.text'),
                        _classes: 'sorter-text'
                    },
                    { key: 'actions', label: '', sorter: false, filter: false }
                ]
            }

            return [
                {
                    key: 'id',
                    label: this.__('settings.tax-rules-credit-notes.index.table.headers.id'),
                    _classes: 'sorter-country'
                },
                {
                    key: 'country_name',
                    label: this.__('settings.tax-rules-credit-notes.index.table.headers.country_name'),
                    _classes: 'sorter-country'
                },
                {
                    key: 'tax_rate',
                    label: this.__('settings.tax-rules-credit-notes.index.table.headers.tax_rate'),
                    _classes: 'sorter-tax-rate'
                },
                {
                    key: 'tax_key',
                    label: this.__('settings.tax-rules-credit-notes.index.table.headers.tax_key'),
                    _classes: 'sorter-tax-key'
                },
                {
                    key: 'customer_type',
                    label: this.__('settings.tax-rules-credit-notes.index.table.headers.customer_type'),
                    _classes: 'sorter-customer-type'
                },
                {
                    key: 'no_tax',
                    label: this.__('settings.tax-rules-credit-notes.index.table.headers.no_tax'),
                    _classes: 'sorter-no-tax'
                },
                {
                    key: 'expense_account',
                    label: this.__('settings.tax-rules-credit-notes.index.table.headers.expense_account'),
                    _classes: 'sorter-expense-account'
                },
                {
                    key: 'credit_note_type_name',
                    label: this.__('settings.tax-rules-credit-notes.index.table.headers.credit_note_type_name'),
                    _classes: 'sorter-credit-note-type'
                },
                {
                    key: 'text',
                    label: this.__('settings.tax-rules-credit-notes.index.table.headers.text'),
                    _classes: 'sorter-text'
                },
                { key: 'actions', label: '', sorter: false, filter: false }
            ]
        }
    },
    methods: {
        editTaxRulesCreditNotesLink (id) {
            return this.$route('settings.tax-rules-credit-notes.edit', { tax_rules_credit_note: id })
        },
        deleteTaxRule (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('settings.tax-rules-credit-notes.destroy', { tax_rules_credit_note: id }))
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        }
    }
}
</script>
